import React, { useEffect } from "react";


const useScript = (url) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

const YouTubeSubscribe = () => {
  return (
    <>
      <div>{useScript("https://apis.google.com/js/platform.js")}</div>
      <div
        className="g-ytsubscribe"
        data-channelid="UCcd1FbZSZADyO9Lh573Rx2w"
        data-layout="default"
        data-theme="dark"
        data-count="hidden"
      ></div>
    </>
  );
}

export default YouTubeSubscribe;




